const NOT_VALID_FILE = ' is not a valid file format.';
const NOT_VALID_FILE_SIZE = 'MB and exceeds the size limit.';
const NO_FILE_PRESENT = `You have to select a file to click "Upload".`;
const ATMOST_10_FILES = 'You can upload 10 files at a time.';
const UploadBoxConstants = {
  NOT_VALID_FILE,
  NOT_VALID_FILE_SIZE,
  NO_FILE_PRESENT,
  ATMOST_10_FILES
};
export default UploadBoxConstants;
//# sourceMappingURL=index.js.map